import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import CouponAdminPage from "./CouponPage";

type TabKey = "product" | "service" | "veterinarian";

export default function CouponsMainPage() {
  const [activeTab, setActiveTab] = useState<TabKey>("product");

  const buttonStyle = (tab: TabKey, bgColor: string, shadowColor: string) => ({
    boxShadow:
      activeTab === tab
        ? `0 4px 10px ${shadowColor}, inset 0 2px 0 rgba(255,255,255,0.3)`
        : `0 2px 6px rgba(156,163,175,0.4), inset 0 1px 0 rgba(255,255,255,0.2)`,
    backgroundColor: activeTab === tab ? bgColor : "#9CA3AF",
    color: activeTab === tab ? "#fff" : "#111827",
    padding: "0.5rem 1rem",
    borderRadius: "1rem",
    fontWeight: 500,
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s",
  });

  return (
    <Layout>
      <Box sx={{ px: 2, py: 4 }}>
        {/* Tabs */}
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <button
            onClick={() => setActiveTab("product")}
            style={buttonStyle("product", "#EF4444", "rgba(239,68,68,0.6)")}
          >
            Products
          </button>

          <button
            onClick={() => setActiveTab("service")}
            style={buttonStyle("service", "#22C55E", "rgba(34,197,94,0.6)")}
          >
            Services
          </button>

          <button
            onClick={() => setActiveTab("veterinarian")}
            style={buttonStyle("veterinarian", "#3B82F6", "rgba(59,130,246,0.6)")}
          >
            Veterinarian
          </button>
        </Box>

        {/* Content section */}
        <Box>
          {activeTab === "product" && (
            <CouponAdminPage />
          )}
          {activeTab === "service" && (
            <Typography variant="h6" color="text.secondary">
              Service Coupons will be developed soon.
            </Typography>
          )}
          {activeTab === "veterinarian" && (
            <Typography variant="h6" color="text.secondary">
              Veterinarian Coupons will be developed soon.
            </Typography>
          )}
        </Box>
      </Box>
    </Layout>
  );
}
